/**
 * Blueprint Pricing + Appstle (single product)
 *
 * Only initializes when blueprint/Appstle UI exists on the page, so the Shapes setting
 * “Open modal when product is added to cart” stays effective on all other products.
 *
 * #btn-one-time-payment / #btn-payment-plan — Appstle selling_plan + /cart/add.js
 *
 * Shapes (Switch Themes): opens cart drawer immediately, then theme:update:cart refreshes sections.
 * Dawn renderContents is skipped by default on Shapes because it can prevent the theme’s
 * cart sections from refreshing (subscription lines especially).
 */
(function () {
  var SUBSCRIPTION_SELLING_PLAN_ID = '5342494972';
  var APPSTLE_ONE_TIME_RADIO_ID = '';
  var DELAY_BEFORE_ADD_MS = 50;

  /**
   * Switch Themes Shapes: do not use Dawn cart-drawer renderContents — it can return early
   * and block theme:update:cart, so the drawer stays empty until full page reload.
   * Set false only if you use Dawn (or a theme that relies on cart-drawer.renderContents).
   */
  var SHAPES_THEME = true;

  function isBlueprintProductPage() {
    return !!document.querySelector(
      '#btn-one-time-payment, #btn-payment-plan, #blueprint-pricing, [data-blueprint-appstle]'
    );
  }

  function getVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var i;
    var el;
    for (i = 0; i < forms.length; i++) {
      el = forms[i].querySelector('[name="id"]');
      if (el && el.value) return el.value;
    }
    var pf = document.querySelector('product-form');
    if (pf) {
      el = pf.querySelector('[name="id"]');
      if (el && el.value) return el.value;
    }
    el = document.querySelector('input[name="id"], select[name="id"]');
    return el && el.value ? el.value : null;
  }

  function parsePlanId(str) {
    var n = parseInt(String(str).trim(), 10);
    return isNaN(n) ? null : n;
  }

  function findSellingPlanRadioByValue(value) {
    var radios = document.querySelectorAll('input[name="selling_plan"][type="radio"]');
    var v = String(value);
    var r;
    for (var i = 0; i < radios.length; i++) {
      r = radios[i];
      if (String(r.value) === v) return r;
    }
    return null;
  }

  function findAppstleOneTimeRadio() {
    if (APPSTLE_ONE_TIME_RADIO_ID) {
      var byId = document.getElementById(APPSTLE_ONE_TIME_RADIO_ID);
      if (byId && byId.getAttribute('name') === 'selling_plan') return byId;
    }
    return findSellingPlanRadioByValue('');
  }

  function selectSellingPlanRadioSilently(radio) {
    if (!radio) return false;
    document.querySelectorAll('input[name="selling_plan"][type="radio"]').forEach(function (inp) {
      inp.checked = false;
    });
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }

  function selectOneTimeSellingPlanUi() {
    var radio = findAppstleOneTimeRadio();
    if (selectSellingPlanRadioSilently(radio)) return true;
    document.querySelectorAll('select[name="selling_plan"]').forEach(function (sel) {
      var opt = sel.querySelector('option[value=""]');
      if (opt) {
        sel.value = '';
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    return !!radio;
  }

  function selectSubscriptionSellingPlanUi(planIdStr) {
    var planId = parsePlanId(planIdStr);
    if (!planId) return false;
    var planStr = String(planId);
    var radio = findSellingPlanRadioByValue(planStr);
    if (radio) return selectSellingPlanRadioSilently(radio);

    var singleInput = document.querySelector(
      'input[name="selling_plan"]:not([type="radio"]):not([type="checkbox"])'
    );
    if (singleInput) {
      singleInput.value = planStr;
      singleInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var sel = document.querySelector('select[name="selling_plan"]');
    if (sel) {
      sel.value = planStr;
      if (sel.value === planStr) {
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function attachSectionsPayload(payload) {
    if (SHAPES_THEME) return payload;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }

  function openDrawerFromAddResponse(parsedState) {
    if (SHAPES_THEME) return false;
    var drawer = document.querySelector('cart-drawer');
    if (
      drawer &&
      parsedState &&
      parsedState.sections &&
      typeof drawer.renderContents === 'function'
    ) {
      drawer.renderContents(parsedState);
      return true;
    }
    return false;
  }

  /** Shapes side cart: same as theme-events — Alpine `modals.open('cart')` when cartType is modal. */
  function openShapesCartDrawer() {
    try {
      if (
        window.theme &&
        window.theme.settings &&
        window.theme.settings.cartType === 'modal' &&
        typeof Alpine !== 'undefined' &&
        typeof Alpine.store === 'function'
      ) {
        var modals = Alpine.store('modals');
        if (modals && modals.modals && modals.modals.cart) {
          if (typeof modals.closeAll === 'function') modals.closeAll();
          modals.open('cart');
          return;
        }
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer', { bubbles: true }));
  }

  /**
   * Shapes: open the drawer right away (feels instant), then refresh cart sections in the
   * background. A short second refresh helps subscription / Appstle lines that lag one tick.
   * @see https://help.switchthemes.co/shapes/developer/theme-events/control-events
   */
  function shapesRefreshCartAndOpenDrawer() {
    openShapesCartDrawer();
    document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
    }, 80);
  }

  function postAddToCartUI(data) {
    if (!SHAPES_THEME && openDrawerFromAddResponse(data)) {
      return;
    }

    shapesRefreshCartAndOpenDrawer();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
        );
      })
      .catch(function () {});
  }

  function addToCartAfterUiSync(sellingPlanId) {
    var variantId = getVariantId();
    if (!variantId) {
      console.warn('Blueprint Pricing: no variant id.');
      alert('Could not find a variant. Try again on the product page.');
      return;
    }

    var payload = {
      id: parseInt(variantId, 10),
      quantity: 1
    };
    if (sellingPlanId != null && String(sellingPlanId).trim() !== '') {
      payload.selling_plan = parseInt(String(sellingPlanId).trim(), 10);
    }

    attachSectionsPayload(payload);

    function tryAdd(body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            return Promise.reject(err);
          });
        }
        return res.json();
      });
    }

    tryAdd(payload)
      .catch(function (firstErr) {
        if (payload.sections) {
          var lean = {
            id: payload.id,
            quantity: payload.quantity
          };
          if (payload.selling_plan != null) lean.selling_plan = payload.selling_plan;
          return tryAdd(lean);
        }
        return Promise.reject(firstErr);
      })
      .then(function (data) {
        postAddToCartUI(data);
      })
      .catch(function (err) {
        console.error('Blueprint Pricing add to cart:', err);
        var msg =
          (err && (err.description || err.message)) ||
          (typeof err === 'string' ? err : '') ||
          'Could not add to cart.';
        alert(msg);
      });
  }

  function runOneTimePayment() {
    selectOneTimeSellingPlanUi();
    window.setTimeout(function () {
      addToCartAfterUiSync(null);
    }, DELAY_BEFORE_ADD_MS);
  }

  function runPaymentPlan() {
    selectSubscriptionSellingPlanUi(SUBSCRIPTION_SELLING_PLAN_ID);
    window.setTimeout(function () {
      addToCartAfterUiSync(SUBSCRIPTION_SELLING_PLAN_ID);
    }, DELAY_BEFORE_ADD_MS);
  }

  function stopNav(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }

  function onOneTimeClick(e) {
    stopNav(e);
    runOneTimePayment();
  }

  function onPaymentPlanClick(e) {
    stopNav(e);
    runPaymentPlan();
  }

  function onDocumentClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#btn-one-time-payment')) {
      onOneTimeClick(e);
      return;
    }
    if (t.closest('#btn-payment-plan')) {
      onPaymentPlanClick(e);
      return;
    }

    var root = document.getElementById('blueprint-pricing');
    if (!root || !root.contains(t)) return;
    if (t.closest('a[href]')) return;

    var option = t.closest('[data-selling-plan]');
    if (!option) return;

    stopNav(e);
    var plan = option.getAttribute('data-selling-plan');
    if (plan === null) return;
    if (String(plan).trim() === '') {
      runOneTimePayment();
    } else {
      selectSubscriptionSellingPlanUi(plan);
      window.setTimeout(function () {
        addToCartAfterUiSync(plan);
      }, DELAY_BEFORE_ADD_MS);
    }
  }

  function init() {
    if (!isBlueprintProductPage()) return;
    if (window.__blueprintPricingBound) return;
    window.__blueprintPricingBound = true;
    document.addEventListener('click', onDocumentClick, true);
  }

  function boot() {
    init();
    window.setTimeout(init, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();







$(document).ready(function () {

   $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    
    const target = $(this).attr('href');
    
    // Bail if no target or just "#"
    if (!target || target === '#') return;
    
    const $target = $(target);
    
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top
      }, 600, 'swing');
    }
  });

// Wait for the element to appear in the DOM
function waitForElement(selector, callback) {
  const element = document.querySelector(selector);
  
  if (element) {
    callback(element);
    return;
  }
  
  const observer = new MutationObserver(function(mutations) {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect();
      callback(element);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Watch for booking modal to open inside ReactModalPortal
function watchModalOpen() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        // Check if the added node is the modal overlay
        if (node.classList && node.classList.contains('ReactModal__Overlay')) {
          console.log('ReactModal__Overlay detected!');
          
          // Wait for the content to fully load
          setTimeout(function() {
            const quantityContainer = node.querySelector('div[data-servicify="number-attending-container"]');
            
            if (quantityContainer) {
              console.log('✓ Booking form modal opened!');
              
              const quantityInput = quantityContainer.querySelector('input');
              if (quantityInput) {
                // Remove old listener flag to allow re-initialization
                quantityInput.removeAttribute('data-listeners-attached');
                
                // Wait for app to set the quantity value
                setTimeout(function() {
                  const currentValue = parseInt(quantityInput.value) || 1;
                  console.log('Modal opened - Quantity value:', currentValue);
                  
                  // Initialize fields based on quantity
                  handleAttendeeChange(currentValue);
                  
                  // Set up listeners
                  setupQuantityListeners(quantityInput);
                  
                  // Set up book now validation
                  const bookButton = node.querySelector('button[data-servicify="servicify-add-to-cart-button"]');
                  if (bookButton) {
                    bookButton.removeAttribute('data-validation-attached');
                    setupBookNowValidation();
                  }
                }, 400);
              }
            } else {
              console.log('Not a booking modal - no quantity container found');
            }
          }, 100);
        }
      });
    });
  });
  
  // Watch the ReactModalPortal specifically
  const portalElement = document.querySelector('.ReactModalPortal');
  if (portalElement) {
    observer.observe(portalElement, {
      childList: true,
      subtree: true
    });
    console.log('Watching .ReactModalPortal for modal changes');
  } else {
    // Fallback to watching document.body if portal doesn't exist yet
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    console.log('Watching document.body for modal changes');
  }
}

// Function to set up quantity input listeners
function setupQuantityListeners(input) {
  if (input.hasAttribute('data-listeners-attached')) {
    console.log('Listeners already attached, skipping...');
    return;
  }
  
  console.log('Setting up quantity listeners...');
  input.setAttribute('data-listeners-attached', 'true');
  
  const container = input.closest('div[data-servicify="number-attending-container"]');
  const buttons = container.querySelectorAll('div[style*="cursor: pointer"]');
  
  console.log('Found +/- buttons:', buttons.length);
  
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      console.log('Button clicked:', button.textContent.trim());
      
      setTimeout(function() {
        console.log('Value after click:', input.value);
        handleAttendeeChange(input.value);
      }, 100);
    });
  });
  
  input.addEventListener('change', function() {
    console.log('Value changed:', this.value);
    handleAttendeeChange(this.value);
  });
  
  input.addEventListener('input', function() {
    console.log('Value input:', this.value);
    handleAttendeeChange(this.value);
  });
  
  console.log('✓ Quantity listeners set up successfully!');
}

// Initialize modal watcher
watchModalOpen();

function handleAttendeeChange(count) {
  const attendeeCount = parseInt(count) || 1;
  console.log('>>> Handling attendee change, count:', attendeeCount);
  
  toggleAttendeeFields(attendeeCount);
}

function toggleAttendeeFields(count) {
  const fieldWrappers = document.querySelectorAll('div[data-servicify="custom-field-wrapper"]');
  
  console.log('>>> Toggling fields - found:', fieldWrappers.length, 'wrappers | showing up to person:', count);
  
  fieldWrappers.forEach(function(wrapper) {
    const label = wrapper.querySelector('label');
    
    if (label) {
      const labelText = label.textContent.trim().toLowerCase();
      const personMatch = labelText.match(/person\s+(\d+)/i);
      
      if (personMatch) {
        const personNumber = parseInt(personMatch[1]);
        const inputs = wrapper.querySelectorAll('input, select, textarea');
        
        if (personNumber <= count) {
          wrapper.style.display = '';
          
          if (personNumber > 1) {
            inputs.forEach(function(input) {
              input.setAttribute('required', 'required');
              input.setAttribute('data-attendee-required', 'true');
            });
            
            if (!label.querySelector('.required-asterisk')) {
              const asterisk = document.createElement('span');
              asterisk.className = 'required-asterisk';
              asterisk.style.color = 'red';
              asterisk.textContent = ' *';
              label.appendChild(asterisk);
            }
            
            console.log('  ✓ SHOWING person', personNumber);
          }
        } else {
          wrapper.style.display = 'none';
          
          inputs.forEach(function(input) {
            input.removeAttribute('required');
            input.removeAttribute('data-attendee-required');
            input.value = '';
            input.style.border = '';
          });
          
          const asterisk = label.querySelector('.required-asterisk');
          if (asterisk) {
            asterisk.remove();
          }
          
          console.log('  ✗ HIDING person', personNumber);
        }
      } else {
        wrapper.style.display = '';
      }
    }
  });
}

function setupBookNowValidation() {
  waitForElement('button[data-servicify="servicify-add-to-cart-button"]', function(bookButton) {
    console.log('Book Now button found!');
    
    if (bookButton.hasAttribute('data-validation-attached')) {
      console.log('Validation already attached to button');
      return;
    }
    
    bookButton.setAttribute('data-validation-attached', 'true');
    
    const originalOnClick = bookButton.onclick;
    bookButton.onclick = null;
    
    bookButton.addEventListener('click', function(e) {
      console.log('Book Now clicked - validating fields...');
      
      const requiredFields = document.querySelectorAll('input[data-attendee-required="true"]');
      const emptyFields = [];
      
      requiredFields.forEach(function(field) {
        const wrapper = field.closest('div[data-servicify="custom-field-wrapper"]');
        if (wrapper && wrapper.style.display !== 'none') {
          if (!field.value.trim()) {
            emptyFields.push(field);
          }
        }
      });
      
      if (emptyFields.length > 0) {
        e.stopPropagation();
        e.preventDefault();
        
        console.log('❌ Validation failed! Empty fields:', emptyFields.length);
        
        emptyFields[0].focus();
        emptyFields[0].style.border = '2px solid red';
        
        let errorMsg = document.getElementById('attendee-error-message');
        if (!errorMsg) {
          errorMsg = document.createElement('div');
          errorMsg.id = 'attendee-error-message';
          errorMsg.style.cssText = 'color: red; font-weight: bold; margin: 10px 0; padding: 10px; background: #ffebee; border-radius: 5px;';
          bookButton.parentElement.insertBefore(errorMsg, bookButton);
        }
        errorMsg.textContent = 'Please fill in all required fields for all attendees before booking.';
        
        emptyFields.forEach(function(field) {
          field.addEventListener('input', function() {
            this.style.border = '';
          }, { once: true });
        });
        
        return false;
      } else {
        console.log('✓ Validation passed!');
        
        const errorMsg = document.getElementById('attendee-error-message');
        if (errorMsg) {
          errorMsg.remove();
        }
        
        if (originalOnClick) {
          originalOnClick.call(bookButton, e);
        }
      }
    }, true);
  });
}
    // Handle category button click
    $(".category-btn").click(function() {
      $(".category-modal").show();
    });
    
    // Handle modal close buttons
    $(".modal-close-btn").click(function() {
      $(this).closest(".modal-container").hide();
    });
    
    // Handle backdrop click to close modals
    $(".modal-backdrop").click(function() {
      $(this).closest(".modal-container").hide();
    });
    
    // Handle ESC key to close modals
    $(document).keydown(function(e) {
      if (e.key === "Escape") {
        $(".modal-container").hide();
      }
    });
   
    $('footer h2.font-heading').click(function(e){
        e.preventDefault();
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    });
    if (!$('.recommended-products').hasClass('slick-initialized')) {
      $('.recommended-products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        fade:true,
        infinite:false
      });
    }

  
    var initSlick = function() {
        var windowWidth = $(window).width();
        
        if (windowWidth <= 989) {
          // Only initialize if not already initialized
          if (!$('.blog-slider').hasClass('slick-initialized')) {
            $('.blog-slider').slick({
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 5000,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    centerPadding: '40px'
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.blog-slider').hasClass('slick-initialized')) {
            $('.blog-slider').slick('unslick');
          }
        }
        
        if (windowWidth <= 989) {
         if (!$('.expandable-images-grid').hasClass('slick-initialized')) {
            $('.expandable-images-grid').slick({
              slidesToShow: 2,
              arrows: false,
              dots: true,
              autoplay: true,
              autoplaySpeed: 5000,
              responsive: [
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.expandable-images-grid').hasClass('slick-initialized')) {
            $('.expandable-images-grid').slick('unslick');
          }
        }
        
        if (windowWidth <= 989) {
          // Only initialize if not already initialized
          if (!$('.related-slider').hasClass('slick-initialized')) {
            $('.related-slider').slick({
              slidesToShow: 2,
              arrows: false,
              dots: true,
              autoplay: false,
              responsive: [
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.related-slider').hasClass('slick-initialized')) {
            $('.related-slider').slick('unslick');
          }
        }

      if (windowWidth <= 600) {
          // Only initialize if not already initialized
          if (!$('.related-posts-slider').hasClass('slick-initialized')) {
            $('.related-posts-slider').slick({
              slidesToShow: 1,
              arrows: false,
              dots: true,
              autoplay: false,
              infinite:false
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.related-posts-slider').hasClass('slick-initialized')) {
            $('.related-posts-slider').slick('unslick');
          }
        }
    };
    
    // Initialize on page load with a slight delay to ensure all elements are properly rendered
    setTimeout(function() {
        initSlick();
    }, 100);
    
    // Handle resize events
    $(window).on('resize', function() {
      initSlick();
    });
    $('.shop-dropdown-menu ul li:last-child a').attr("href","/collections/all");

    function initUpsellSlider() {
    const $slider = $('.upsells-slider');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 5000,
            infinite:true,
            prevArrow: '<a href=":javascript;" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left size-6"><path d="m15 18-6-6 6-6"></path></svg></a>',
            nextArrow: '<a href=":javascript;" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right size-6"><path d="m9 18 6-6-6-6"></path></svg></a>',
            /*responsive: [
              {
                breakpoint: 480,
                settings: {
                  dots: true,
                  arrows: false,
                }
              }
              ]*/
        });
      } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }

    initUpsellSlider();

    // Re-run after cart updates (Shopify AJAX themes often dispatch 'cart:updated')
  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('cart:updated', function () {
      setTimeout(initUpsellSlider, 100); // delay a bit for DOM injection
    });
  });
  
  // Fallback: use mutation observer if no cart event
  const observer = new MutationObserver(function () {
    initUpsellSlider();
  });
  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true
  });
});